import React from 'react';
import { Modal, Button } from '@cochlear-design-system/foundation';

export const ModalFooter = ({ hideModal, labels }) => {
  return (
    <Modal.Footer>
      <Button
        text={labels['labels.findClinicModal.close']}
        variant="secondary"
        onClick={hideModal}
        data-analytics="close_find_clinic"
      />
    </Modal.Footer>
  );
};
